import type { ReactNode } from "react";

interface PageFooterProps {
  /** Footer content — typically a copyright `T` plus a few `Link`s. */
  children: ReactNode;
}

/**
 * Centered, wrapping footer bar for small-print page chrome (copyright + legal
 * links). The design system owns this bespoke layout so app and feature code
 * stay className-free — callers just pass `T` / `Link` children. Pair with
 * `StickyFooterLayout` to pin it to the bottom of short pages.
 */
export function PageFooter({ children }: PageFooterProps) {
  return (
    <footer className="mt-8 mb-4 flex flex-wrap items-center justify-center gap-4 text-xs">
      {children}
    </footer>
  );
}
